export const DefaultTranslations = {
    "facebook_app_id": "222169131296470",
    "com.crashlytics.android.build_id": "RANDOM_UUID",
    "com.crashlytics.android.build_id__#": "<string name=\"google_app_id\">177818426888</string>",
    "app_name": "Football Mania",
    "app_logo_name": "Football Live Scores",
    "standen": "Standings",
    "reload": "Reload",
    "loading": "Loading...",
    "nointernet": "No internet connection",
    "noconnnection": "Can't connect",
    "noserverconnection": "Could not connect to the server",
    "tryagain": "Try again",
    "settings": "Settings",
    "no_data": "No data found",
    "selectcompetition": "Competitions",
    "morecompetition": "More competitions",
    "matchinfo": "Match info",
    "matchpreview": "Match preview",
    "matchreport": "Match report",
    "article_show_more": "Show more",
    "article_show_less": "Show less",
    "lineups": "Line-ups",
    "teaminfo": "Team info",
    "squad": "Squad",
    "venue": "Venue",
    "capacity": "Capacity",
    "surface": "Surface",
    "transfers": "Transfers",
    "founded": "Founded",
    "coach": "Coach",
    "country": "Country",
    "attacker": "Forward",
    "midfielder": "Midfielder",
    "defender": "Defender",
    "goalkeeper": "Goalkeeper",
    "loan": "Loan",
    "from": "From",
    "to": "To",
    "free": "Free",
    "unknown": "Unknown",
    "schedule": "Schedule",
    "live": "Live",
    "nowlive": "Now live",
    "live_matches": "Live matches",
    "todays_matches": "Today's matches",
    "tomorrow": "Tomorrow",
    "currently_no_matches": "Currently no matches",
    "todaysmatches": "Today",
    "thisweekmatches": "This week",
    "nextweekmatches": "Next week",
    "round": "Round",
    "topscoreplayers": "Top scorers",
    "career": "Career",
    "passport": "Personal details",
    "season": "Season",
    "team": "Team",
    "age": "Age",
    "nationality": "Nationality",
    "birthplace": "Birthplace",
    "position": "Position",
    "weight": "Weight",
    "height": "Height",
    "competition": "Competition",
    "Europe": "Europe",
    "Asia": "Asia",
    "South_America": "South America",
    "Africa": "Africa",
    "Oceania": "Oceania",
    "North_Central_America": "North and Central America",
    "World_Cup": "World Cup",
    "World_Cup_Qualifications": "World Cup qualifiers",
    "International_Cups": "International cups",
    "Eurocups": "European cups",
    "votes": "Votes",
    "voteMatch": "Vote",
    "already_voted": "You voted",
    "shotstotals": "Total shots",
    "shotsgoal": "Shots on target",
    "goal": "Goal",
    "goals": "Goals",
    "fouls": "Fouls",
    "possessiontime": "Possession",
    "corners": "Corners",
    "offsides": "Offsides",
    "yellowcard": "Yellow card",
    "yellowcards": "Yellow cards",
    "redcard": "Red card",
    "redcards": "Red cards",
    "saves": "Saves",
    "odds": "Odds",
    "threewayhandicap": "3-way handicap",
    "stats": "Stats",
    "rank": "Rank",
    "cleansheet": "Clean sheet",
    "avggoalspergamescored": "Average goals scored per game",
    "avggoalspergameconceded": "Average goals conceded per game",
    "avgfirstgoalscored": "Average first goal scored",
    "avgfirstgoalconceded": "Average first goal conceded",
    "failedtoscore": "Failed to score",
    "scoringminutes": "Scoring minutes",
    "sidelined": "Sidelined",
    "home": "Home",
    "away": "Away",
    "total": "Total",
    "table_gamesplayed_full": "Games played",
    "table_gamesplayed": "GP",
    "table_points_full": "Points",
    "table_points": "Pts",
    "table_wins_full": "Won",
    "table_wins": "W",
    "table_draw_full": "Drawn",
    "table_draw": "D",
    "table_lost_full": "Lost",
    "table_lost": "L",
    "table_goalsagainst_full": "Goals against",
    "table_goalsfor_full": "Goals for",
    "table_goalsforagainst": "GF-GA",
    "table_goalsforagainst_full": "Goal difference",
    "table_goaldiff": "GD",
    "favorites": "Favourites",
    "favoriteteams": "Favourite teams",
    "favoriteleagues": "Favourite competitions",
    "substitutions": "Substitutions",
    "videos": "Videos",
    "searchresults": "Search results",
    "teams": "Teams",
    "league": "League",
    "leagues": "Leagues",
    "sounds": "Sounds",
    "entertainment": "Entertainment",
    "interrupted": "Interrupted",
    "city": "City",
    "world_ranking_list": "FIFA World Ranking",
    "menu_favorite_team": "Favourite team",
    "menu_favorite_league": "Favourite competition",
    "menu_refresh": "Refresh",
    "menu_search": "Search",
    "menu_sharematch": "Share",
    "menu_unsubscribe": "Unsubscribe",
    "menu_subscribe": "Subscribe",
    "comments": "Chat",
    "previous_matches": "Previous matches",
    "versus": "Versus",
    "interrupted_short": "Intr.",
    "finaltime": "Full time",
    "finaltime_short": "FT",
    "halftime": "Half time",
    "halftime_short": "HT",
    "after_extra_time": "After extra time",
    "after_extra_time_short": "AET",
    "to_be_announced": "To be announced",
    "to_be_announced_short": "TBA",
    "penalty": "Penalty",
    "penalty_short": "Pen.",
    "postponed": "Postponed",
    "postponed_short": "Postp.",
    "abandoned": "Abandoned",
    "cancelled": "Cancelled",
    "cancelled_short": "Can.",
    "abandoned_short": "Aban.",
    "more_team_battle_info": "More team statistics",
    "news": "News",
    "source": "Source",
    "please_login": "Please sign in",
    "back": "Back",
    "close": "Close",
    "advertisement": "Advertisement",
    "we_are_sorry": "We're sorry!",
    "no_player_info": "We have no further information on this player yet",
    "ok": "OK",
    "push_notification_warning": "You have enabled push notifications for this match. You will be notified when a goal is scored and when the match ends.",
    "ok_got_it": "OK, got it!",
    "no_match_info": "No match facts available",
    "no_team_info": "Sorry, we don't have any info on this team",
    "no_squad_info": "No squad found",
    "no_transfer_info": "No transfers found",
    "no_topscorers_info": "No top scorers yet",
    "none": "None",
    "relegation": "Relegation",
    "promotion": "Promotion",
    "promotion_playoff": "Promotion play-off",
    "show_only_top_leagues": "Show only top leagues",
    "show_all": "Show all",
    "no_live_matches": "There are currently no live matches",
    "notification_sound": "Notification sound",
    "notification_vibration_enabled": "Vibrate on notification",
    "voting_statistics": "Voting statistics",
    "apply_filter": "Apply filter",
    "all_time": "All time",
    "extra_time_short": "ET",
    "tap_again_to_exit": "Tap again to exit",
    "match_started": "Match started",
    "website": "Website",
    "Northern_Ireland": "Northern Ireland",
    "assist": "Assist",
    "h2h": "Head-to-head",
    "liveticker": "Live ticker",
    "agenda": "Calendar",
    "vkontakte": "ВКонтакте",
    "aggregate": "On aggregate",
    "winner": "Winner:",
    "selectitemtoswap": "Select highlighted item to swap",
    "chattypehint": "Type your message here",
    "silent": "Silent",
    "ringtoneTitle": "Ringtone",
    "ringtoneSummary": "Ringtone: %s",
    "language": "Language",
    "contact": "Contact",
    "feedback_and_support": "Feedback & support",
    "summary": "We appreciate your feedback: it helps us give you and other users the best possible experience. Let us know your questions, issues and suggestions by clicking here or emailing World.Sport.Apps@Gmail.com",
    "starts_in": "Starts in %{param1} minutes",
    "announcement": "Announcement",
    "notification_enabled_types": "Enabled notifications",
    "reset_application": "Reset app",
    "reset_application_summary": "Restore the app to its default settings",
    "reset_application_summary_extended": "This action will reset all favourites, push notifications and other custom settings. Are you sure you want to continue?",
    "resumed": "Resumed",
    "enabled": "Enabled",
    "vibration_enabled": "Vibrate on alert",
    "wake_when_push_notification_arrives": "Wake screen when a notification arrives",
    "notification_high_prio_enabled": "High-priority notifications",
    "England": "England",
    "Scotland": "Scotland",
    "Wales": "Wales",
    "Moldovia": "Moldova",
    "Azerbaijan": "Azerbaijan",
    "Cambodia": "Cambodia",
    "Congo_Kinshasa": "Congo-Kinshasa",
    "Guadeloupe": "Guadeloupe",
    "Ivory_Coast": "Ivory Coast",
    "remove_ads": "Remove ads",
    "remove_ads_summary": "Please choose one of the following options:",
    "remove_ads_summary_offer_short": "Select this to remove advertising",
    "remove_ads_summary_offer": "Remove advertising by subscribing to one of the options below. Your subscription renews automatically at the end of each subscription period. You can cancel your subscription here",
    "premium_subscription_info_title": "You have an active premium subscription",
    "premium_subscription_info_expiration_status": "",
    "remove_premium_subscription_info_guide": "Click here to manage your Google app subscriptions",
    "remove_premium_autorenew_on": "Your subscription renews automatically",
    "remove_premium_autorenew_off": "Your subscription has been cancelled and will not renew automatically",
    "remove_advertising_one_month": "1-month subscription",
    "remove_advertising_six_months": "6-month subscription",
    "remove_advertising": "1-year subscription",
    "remove_advertising_oneweek": "1-week subscription",
    "extraRingtones": [
        "whistle1",
        "whistle2",
        "whistle3",
        "whistle4",
        "whistle5",
        "whistle6",
        "whistle7",
        "whistle8",
        "whistle9",
        "whistle10",
        "whistle11",
        "whistle12",
        "crowd1",
        "crowd2",
        "crowd3"
    ],
    "extraRingtoneTitles": [
        "Whistle 1",
        "Whistle 2",
        "Whistle 3",
        "Whistle 4",
        "Whistle 5",
        "Whistle 6",
        "Whistle 7",
        "Whistle 8",
        "Whistle 9",
        "Whistle 10",
        "Whistle 11",
        "Whistle 12",
        "Crowd 1",
        "Crowd 2",
        "Crowd 3"
    ],
    "extra_time": "Extra time",
    "offline_mode": "Offline",
    "beta_test": "Beta testing",
    "beta_test_summary": "Interested in trying out the newest features? Click here to join the beta programme",
    "reset_cache": "Reset cache",
    "reset_application_cache": "Removes all stored images and offline data",
    "permission_disabled_warning": "\"You have denied permission to read and write data on your phone.\nThe app still works, but performance will be reduced, it will use more data and offline support is disabled.\nYou can enable this permission in your app settings.\"",
    "about_title": "About",
    "about_text": "Special thanks to Arjan Meijer for his high-quality football data, and to the Football Mania community for its valuable input and support. Football Mania is a product created by and for football fans all over the world.\nThanks to Anthony Buttaci for his excellent work updating many team logos.",
    "no_thanks": "No thanks",
    "team_form": "Form",
    "error_no_gcm": "Cannot retrieve the Google Cloud Messaging registration ID. Please update Google Play services",
    "default_home_screen": "Default start screen",
    "watchlist": "My watchlist",
    "fixtures": "Fixtures",
    "push_notification_title": "Push notification registration ID. Click to test and copy to clipboard",
    "enable_community_logo_pack": "Logo pack",
    "enable_community_logo_pack_summary": "Click here to install the fan logo pack",
    "disclaimer": "Disclaimer",
    "installed": "Installed. Click to uninstall",
    "uninstall": "Uninstall",
    "uninstall_logo_pack": "Are you sure you want to uninstall the logo pack?",
    "enable_community_logo_pack_disclaimer": "The logo pack contains images of clubs and players.\nFootball Mania does not own these images. The images are not authorised by, sponsored by or associated with the trademark owner(s).\nAll logos are collected by football fans and are for personal use only. Click OK to install.",
    "pause": "Break",
    "start": "Home",
    "cancel": "Cancel",
    "updated_at": "Last updated",
    "widget_no_data": "There are currently no items on your watchlist and none of your favourite teams are playing.",
    "suspended_short": "Susp.",
    "suspended": "Suspended",
    "favorite_order": "Favourites order",
    "manual": "Manual",
    "alfabetical": "Alphabetical",
    "select_date": "Select a different date from the calendar",
    "top_voters": "Top user predictions",
    "username": "Username",
    "hits": "Correct",
    "misses": "Wrong",
    "info": "Info",
    "last_week": "Last week",
    "last_month": "Last month",
    "login": "Sign in",
    "logout": "Sign out",
    "not_logged_in": "Not signed in",
    "logged_in_as": "Signed in as: %s",
    "logged_out": "Signed out",
    "substitutes": "Substitutes",
    "odd_title": "Odds",
    "bookmaker": "Bookmaker",
    "bookmaker_value_format": "Bookmaker format",
    "odds_preference": "Preferred bookmaker",
    "bookmakers_enabled": "Show bookmakers on match screen",
    "user_fixture_ordering": "Favourites order (live, today, calendar)",
    "Kyrgyzstan": "Kyrgyzstan",
    "preferred_foot": "Preferred foot",
    "privacy": "Privacy policy",
    "profile": "Profile",
    "attendance": "Attendance",
    "predictions": "Predictions",
    "missed_penalty": "Penalty missed",
    "theme": "Theme",
    "theme_black": "Black",
    "theme_white": "White",
    "theme_green": "Green",
    "theme_green2": "Dark green",
    "theme_dblue": "Dark blue",
    "theme_red": "Red",
    "theme_orange": "Desert",
    "theme_blue": "Blue",
    "theme_purple": "Purple",
    "theme_pink": "Pink",
    "font_size": "Font size",
    "font_small": "Small",
    "font_medium": "Medium",
    "font_large": "Large",
    "font_xlarge": "Extra large",
    "graphics": "Graphics",
    "advanced_animations": "Advanced animations",
    "clock_mode": "Clock format",
    "clock_mode_24": "24 hours",
    "clock_mode_12": "12 hours",
    "Tajikistan": "Tajikistan",
    "gibraltar": "Gibraltar",
    "back_button_label": "Back",
    "next_button_label": "Next",
    "skip_button_label": "Skip",
    "skip_button_label__#": "Optional button to Skip a PreferenceActivity [CHAR LIMIT=20]",
    "download": "Download",
    "please_wait": "Please wait",
    "next_match": "Next match on %{param1}",
    "terms_of_service": "Privacy Policy",
    "terms_of_service_popup_title": "",
    "terms_of_service_popup_explained": "We keep this app free by showing ads. We use a unique identifier on your device to serve ads. If you want to avoid any tracking, you can buy the ad-free version of this app.",
    "terms_of_service_popup_introduction": "Scroll down and click \"I agree\" when you are ready to continue with Football Mania Live Scores.",
    "terms_of_service_popup_introduction2": "To comply with data protection laws, we're asking you to take a moment to review the key points of Football Mania's Privacy Policy.",
    "terms_of_service_popup_data_title": "Data we process:",
    "terms_of_service_data_usage_list": "When you use Football Mania Live Scores, we process information about that activity, including information such as your device ID and cookie data.\n  \nWe process that information for services such as ads, analytics and Crashlytics.",
    "terms_of_service_popup_why_usuing_data": "Why we process it:",
    "terms_of_service_popup_why_usuing_data_explained": "We process this data, as described in our policy, in order to:\n\n  \n<li>Help our services deliver more useful, customised content, such as favourites and relevant search results.</li>\n  \n<li>Improve the quality of our services and develop new ones.</li>\n  \n<li>Deliver ads based on your interests.</li>\n  \n<li>Carry out analytics and measurements to understand how our services are used. We use Google Analytics and Crashlytics\n   to understand user behaviour and app crashes.\\n\\nThank you for your attention, \\nThe Football Mania Live Scores team. \\n\\n If you have any questions or feedback, feel free to contact world.sport.apps@gmail.com\\n</li>",
    "terms_of_service_description": "Touch to view Privacy Policy",
    "terms_of_service_cancel_button": "Later",
    "terms_of_service_ok_button": "I agree",
    "overwrite_default_push_notification_behavior": "Enable custom sounds",
    "change_log": "Changelog",
    "change_log_description": "Click to view the changelog and developer notes",
    "notice": "Notice",
    "forum": "Chat",
    "banned": "Banned",
    "chat_vote_disabled": "We have disabled voting for your account. Please contact the app admin for more information",
    "chat_disabled": "This chat room is archived and all activity is disabled.",
    "banned_cannot_post_reason": "Your account is currently banned. Please contact the app admin for more information.",
    "unknown_error": "An unknown error has occurred. Please contact the app admin for more information.",
    "chat_auth_failure": "Authorisation failed. Please try signing in again or contact the app admin for more information.",
    "removed": "Removed",
    "fastscroll_enabled": "Fast scrolling in lists",
    "experimental_mode": "Fancy mode (Android 9+)",
    "International_North_Central_America": "North and Central America",
    "International_Africa": "International Africa",
    "International_Asia": "International Asia",
    "International_Oceania": "International Oceania",
    "International_South_America": "International South America",
    "International": "International",
    "Regions": "Regions",
    "Faroe_islands": "Faroe Islands",
    "venue2": "Venue",
    "possestiontime": "Ball possession",
    "shotsgoalmissed": "Shots off target",
    "shotsgoalblocked": "Blocked shots",
    "passestotal": "Total passes",
    "passesaccurate": "Accurate passes",
    "shotstotal": "Total shots",
    "taptotryagain": "Tap to try again",
    "referee": "Referee",
    "no_schedule_available": "No schedule available",
    "taptoreturn": "Tap to return to previous screen",
    "no_matches_found": "No football matches found",
    "you_have_enabled_favorite_filter": "You have enabled the filter to show only favourite matches and leagues",
    "tap_to_return": "Tap to go back",
    "upcoming_matches": "Upcoming matches",
    "attackers": "Forwards",
    "defenders": "Defenders",
    "midfielders": "Midfielders",
    "goalkeepers": "Goalkeepers",
    "kneeinjury": "Knee injury",
    "minorinjury": "Minor injury",
    "anklefootinjury": "Ankle/foot injury",
    "hamstring": "Hamstring injury",
    "last_played_match": "Last match played",
    "todays_played_match": "Today's match",
    "today": "Today",
    "thighmusclestrain": "Thigh muscle injury",
    "brokenwrist": "Broken wrist",
    "footinjury": "Foot injury",
    "calfmusclestrain": "Calf muscle strain",
    "knock": "Knock",
    "trophies": "Trophies",
    "Kosovo": "Kosovo",
    "incoming_transfers": "Transfers in",
    "outgoing_transfers": "Transfers out",
    "free_exchange": "Free transfer",
    "secondplace": "2nd",
    "firstplace": "1st",
    "dominican_republic": "Dominican Republic",
    "search_your_favorite_teams": "Search for your favourite teams",
    "goal_disallowed": "Goal disallowed",
    "added": "Added",
    "offside": "Offside",
    "address": "Address",
    "penalties": "Penalties",
    "match_events": "Match events",
    "match": "Match",
    "select_news_from_country": "Select news from another country",
    "description_add_news_source": "Missing news from a specific country or language? Let us know by sending us a good news source that supports RSS feeds.",
    "firstname": "First name",
    "lastname": "Last name",
    "injury_still_there": "The injury is still present",
    "date": "Date",
    "injury_type": "Injury type",
    "injury_period": "Injury period",
    "injury_suspended": "Player is suspended",
    "knee_injury": "Knee injury",
    "groin_pelvis_injury": "Groin/pelvis injury",
    "pcl_knee_ligament_injury": "Knee ligament injury",
    "mcl_knee_ligament_injury": "Knee ligament injury",
    "ankle_foot_injury": "Ankle/foot injury",
    "virus": "Virus",
    "illness": "Illness",
    "thigh_muscle_rupture": "Thigh muscle rupture",
    "shoulder_injury": "Shoulder injury",
    "concussion": "Concussion",
    "lcl_knee_ligament_injury": "Knee ligament injury",
    "ankle_ligaments": "Ankle ligament injury",
    "thigh_muscle_strain": "Thigh muscle strain",
    "back_injury": "Back injury",
    "broken_shinbone": "Broken shinbone",
    "period_from": "Period from",
    "period_to": "Period to",
    "days": "days",
    "groin_strain": "Groin strain",
    "calf_shin_injury": "Calf/shin injury",
    "hip_thigh_injury": "Hip/thigh injury",
    "achilles_tendonitis": "Achilles tendonitis",
    "metatarsal_fracture": "Metatarsal fracture",
    "ankle_fracture": "Ankle fracture",
    "injuries": "Injuries",
    "market_value": "Market value",
    "right_foot": "Right foot",
    "left_foot": "Left foot",
    "search_your_favorite_league": "Search for your favourite league/cup",
    "league_add_information": "Below are some suggestions. Use the search above to find more leagues or cups",
    "tap_to_add": "Tap to add",
    "player_market_values": "Player market values",
    "name": "Name",
    "birthdate": "Date of birth",
    "predicted_lineups": "Predicted line-ups",
    "no_chat_messages": "No messages yet",
    "type_below_to_be_first": "Type below to be the first to post a message",
    "shortsclip": "Shorts",
    "highlights": "Highlights",
    "bookmakers_enabled_when_premium": "Show bookmaker ads with premium",
    "filter_by_country": "Filter by country",
    "selected": "Selected:",
    "Democratic_Republic_of_Congo": "Democratic Republic of Congo",
    "Czechia": "Czechia",
    "Congo_DR": "Congo DR",
    "Curaçao": "Curaçao",
    "Korea_Republic": "Korea Republic",
    "North_Macedonia": "North Macedonia",
    "Republic_of_Ireland": "Republic of Ireland",
    "Syria": "Syria",
    "Türkiye": "Türkiye",
    "USA": "USA",
    "Côte_d_Ivoire": "Côte d'Ivoire",
    "playerstats": "Player stats",
    "update_version": "Updating to version {}",
    "sidelined_match": "Sidelined",
    "injury": "Injury",
    "calf_injury": "Calf injury",
    "achilles_tendon_injury": "Achilles tendon injury",
    "muscle_injury": "Muscle injury",
    "health_problems": "Health problems",
    "arm_injury": "Arm injury",
    "groin_injury": "Groin injury",
    "toe_injury": "Toe injury",
    "yellow_cards": "Yellow cards",
    "red_card": "Red card",
    "ankle_injury": "Ankle injury",
    "abdominal_strain": "Abdominal strain",
    "thigh_injury": "Thigh injury",
    "tendon_injury": "Tendon injury",
    "suspended_player": "Suspended",
    "convalescence": "Convalescence",
    "hip_injury": "Hip injury",
    "loan_agreement": "Loan agreement",
    "Curacao": "Curacao",
    "Tripping": "Tripping",
    "Roughing": "Roughing",
    "Foul": "Foul",
    "heart_problems": "Heart problems",
    "doping": "Doping",
    "Unsportsmanlike_conduct": "Unsportsmanlike conduct",
    "Holding": "Holding",
    "user_consent_sumary": "User consent information",
    "data_privacy": "Data privacy",
    "Eswatini": "Eswatini",
    "Laos": "Laos",
    "select_leaguecup": "Select another league/cup",
    "select_season": "Select season",
    "trophy_first": "Winner",
    "trophy_second": "Runner-up",
    "trophyfirst": "1st",
    "trophysecond": "2nd",
    "title_home_screen": "Home screen - Football Mania Live Scores",
    "title_home_today": "Today's matches",
    "title_home_live": "Live matches",
    "euro2024": "European Championship 2024",
    "term.reason.foul": "Foul",
    "term.reason.holding": "Holding",
    "term.reason.tripping": "Tripping",
    "term.reason.roughing": "Rough play",
    "term.reason.diving": "Diving",
    "term.reason.elbowing": "Elbowing",
    "term.reason.delay_of_game": "Time-wasting",
    "term.reason.unsportsmanlike_conduct": "Unsporting behaviour",
    "term.reason.serious_foul": "Serious foul play",
    "term.reason.handling": "Handball",
    "term.reason.not_on_pitch": "Off the pitch",
    "term.reason.head_butting": "Head-butt",
    "term.reason.abuse_of_officials": "Abuse of officials",
    "term.reason.misses_next_match": "Suspended for the next match",
    "term.reason.goal_disallowed": "Goal disallowed",
    "term.reason.goal_disallowed_offside": "Goal disallowed – offside",
    "term.reason.goal_disallowed_foul": "Goal disallowed – foul",
    "term.reason.goal_disallowed_video_review": "Goal disallowed – VAR review",
    "term.absence.suspended": "Suspended",
    "term.absence.red_card": "Red card suspension",
    "term.absence.yellow_cards": "Yellow card suspension",
    "term.absence.doping": "Doping suspension",
    "term.absence.inactive": "Inactive",
    "term.absence.off_the_roster": "Not in squad",
    "term.absence.coach_decision": "Coach's decision",
    "term.absence.international_duty": "International duty",
    "term.absence.loan_agreement": "Loan agreement",
    "term.absence.transfer_negotiations": "Transfer talks",
    "term.absence.personal_reasons": "Personal reasons",
    "term.absence.rest": "Rested",
    "term.absence.tired": "Fatigue",
    "term.absence.lacking_match_fitness": "Lacking match fitness",
    "term.absence.unknown": "Unknown",
    "term.absence.injury": "Injury",
    "term.absence.knock": "Knock",
    "term.absence.minor_injury": "Minor injury",
    "term.absence.illness": "Illness",
    "term.absence.virus": "Virus",
    "term.absence.health_problems": "Health problems",
    "term.absence.medical_condition": "Medical condition",
    "term.absence.stress": "Stress",
    "term.absence.surgery": "Surgery",
    "term.absence.heart_condition": "Heart condition",
    "term.absence.appendicitis": "Appendicitis",
    "term.absence.tonsillitis": "Tonsillitis",
    "term.absence.pneumonia": "Pneumonia",
    "term.absence.cancer": "Cancer",
    "term.absence.bowel_disease": "Bowel disease",
    "term.absence.dental_problems": "Dental problems",
    "term.absence.hernia": "Hernia",
    "term.absence.inguinal_hernia": "Inguinal hernia",
    "term.absence.concussion": "Concussion",
    "term.absence.contusion": "Bruise",
    "term.absence.head_injury": "Head injury",
    "term.absence.facial_injury": "Facial injury",
    "term.absence.eye_injury": "Eye injury",
    "term.absence.mouth_injury": "Mouth injury",
    "term.absence.jaw_injury": "Jaw injury",
    "term.absence.broken_jaw": "Broken jaw",
    "term.absence.broken_nose": "Broken nose",
    "term.absence.fractured_cheekbone": "Fractured cheekbone",
    "term.absence.neck_injury": "Neck injury",
    "term.absence.shoulder_injury": "Shoulder injury",
    "term.absence.dislocated_shoulder": "Dislocated shoulder",
    "term.absence.collarbone_injury": "Collarbone injury",
    "term.absence.broken_collarbone": "Broken collarbone",
    "term.absence.upper_body_injury": "Upper-body injury",
    "term.absence.chest_injury": "Chest injury",
    "term.absence.rib_injury": "Rib injury",
    "term.absence.back_injury": "Back injury",
    "term.absence.lower_back_injury": "Lower back injury",
    "term.absence.abdominal_strain": "Abdominal strain",
    "term.absence.arm_injury": "Arm injury",
    "term.absence.broken_arm": "Broken arm",
    "term.absence.elbow_injury": "Elbow injury",
    "term.absence.wrist_injury": "Wrist injury",
    "term.absence.broken_wrist": "Broken wrist",
    "term.absence.hand_injury": "Hand injury",
    "term.absence.broken_hand": "Broken hand",
    "term.absence.hand_wrist_injury": "Hand/wrist injury",
    "term.absence.thumb_wrist_injury": "Thumb/wrist injury",
    "term.absence.finger_injury": "Finger injury",
    "term.absence.broken_finger": "Broken finger",
    "term.absence.lower_body_injury": "Lower-body injury",
    "term.absence.pelvis_injury": "Pelvis injury",
    "term.absence.groin_injury": "Groin injury",
    "term.absence.groin_strain": "Groin strain",
    "term.absence.groin_pelvis_injury": "Groin/pelvis injury",
    "term.absence.hip_injury": "Hip injury",
    "term.absence.hip_thigh_injury": "Hip/thigh injury",
    "term.absence.gluteal_strain": "Gluteal strain",
    "term.absence.thigh_injury": "Thigh injury",
    "term.absence.thigh_muscle_strain": "Thigh strain",
    "term.absence.thigh_muscle_rupture": "Torn thigh muscle",
    "term.absence.hamstring_injury": "Hamstring injury",
    "term.absence.muscle_injury": "Muscle injury",
    "term.absence.leg_injury": "Leg injury",
    "term.absence.broken_leg": "Broken leg",
    "term.absence.knee_injury": "Knee injury",
    "term.absence.acl_injury": "ACL injury",
    "term.absence.mcl_injury": "MCL injury",
    "term.absence.lcl_injury": "LCL injury",
    "term.absence.pcl_injury": "PCL injury",
    "term.absence.cruciate_ligament_injury": "Cruciate ligament injury",
    "term.absence.meniscus_injury": "Meniscus injury",
    "term.absence.shin_injury": "Shin injury",
    "term.absence.broken_shinbone": "Broken tibia",
    "term.absence.broken_calfbone": "Broken fibula",
    "term.absence.calf_injury": "Calf injury",
    "term.absence.calf_muscle_strain": "Calf strain",
    "term.absence.calf_shin_injury": "Calf/shin injury",
    "term.absence.achilles_tendon_injury": "Achilles tendon injury",
    "term.absence.achilles_strain": "Achilles strain",
    "term.absence.achilles_tendon_rupture": "Ruptured Achilles tendon",
    "term.absence.achilles_tendinitis": "Achilles tendinitis",
    "term.absence.tendon_injury": "Tendon injury",
    "term.absence.ankle_injury": "Ankle injury",
    "term.absence.ankle_ligaments": "Ankle ligament injury",
    "term.absence.broken_ankle": "Broken ankle",
    "term.absence.ankle_foot_injury": "Ankle/foot injury",
    "term.absence.foot_injury": "Foot injury",
    "term.absence.broken_foot": "Broken foot",
    "term.absence.metatarsal_fracture": "Metatarsal fracture",
    "term.absence.heel_injury": "Heel injury",
    "term.absence.toe_injury": "Toe injury",
    "term.absence.broken_toe": "Broken toe",
    "term.absence.jumpers_knee": "Jumper's knee",
    "term.absence.stomach_disorder": "Stomach problem",
    "term.absence.gashed_leg": "Leg laceration"
};
